import * as React from 'react';
import * as qs from 'query-string';
import { Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';

interface IProps { 
    centerId : number;
}
const PatientDonors = (props :IProps ) => {
    const parsed        = qs.parse(typeof window !== 'undefined' ? window.location.search : '');
    const msId          = parsed['recipientId'];

    return (
        <div style={{ marginBottom: 10, padding: '0px 5px 5px 5px' }}>
            <Alert bsStyle='danger'>
                <h2 style={{marginTop:0}}>This page has moved</h2>
                <p>This page has moved to the main DASH Donor Intake section for quicker access to stay up to date on donor registrations for your patients.</p>
                <p>Please <Link to={`/center/${props.centerId}/donors/donor-intake/search-by-intended?micrositeRecipientId=${msId}`}>Click here</Link> to go to new page</p>
            </Alert>
        </div>
    );
}

export default PatientDonors;